import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-chat-bot-asesor-v2-ayuda',
  templateUrl: './chat-bot-asesor-v2-ayuda.component.html',
})
export class ChatBotAsesorV2AyudaComponent {

  urlEmbed = 'https://www.youtube.com/embed/playlist?list=PLyPY_YXy9WJGhmsD0NN1kTBdb0j8bq98Y';
  urlImg = 'https://img.youtube.com/vi/MqFXHQwr5sc/maxresdefault.jpg';
  urlLink = 'https://www.youtube.com/playlist?list=PLyPY_YXy9WJGhmsD0NN1kTBdb0j8bq98Y';

  safeURL: SafeResourceUrl;

  constructor(private _sanitizer: DomSanitizer) {
    this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(this.urlEmbed);
  }

  irVideo() {
    window.open(this.urlLink, '_blank');
  }

}
